// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* 운임 납부 미납(N/A / Not received) 상태 클릭 → 담당 사무소 연락처(Network) 이동 링크 */\n.fr_contact_link[data-v-f1b07fa4] {\n  color: inherit;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  cursor: pointer;\n}\n.fr_contact_link[data-v-f1b07fa4]:hover {\n  font-weight: 700;\n}\n", ""]);
// Exports
module.exports = exports;
